import { getAction } from '@/api/manage.js'
import menu from './menu.js'
export function loadSysRole(back) {
  getAction('/sys/role/byUser').then((response) => {
    let menuList = []
    if (response.success) {
      if (response.result) {
        let showAdminMenu = false
        let menuListTemp = menu.menuList
        response.result.forEach(element => {
          if (element.roleCode === 'role_brand') {
            showAdminMenu = true
          }
        })
        if (showAdminMenu) {
          menuListTemp.forEach(element => {
            if (element.name === 'Product') {
              element.hidden = false
            }
          })
        }
        menuList = menuListTemp
      }

    }
    back(menuList)
  })
}



// WEBPACK FOOTER //
// ./src/pages/components/loadSysRole.js